import { AreaType, INSULATION_AREA_OPTIONS } from '../types/insulation';
import { useInsulationAreaSetting } from '../hooks/useInsulationAreaSetting';
import { ImageRaidoButton } from '../inputs';
import { TKEvent } from '../types';

import { AnimateModal, ModalOpenProps } from '@/components/ui/modal';

/**
 * Insulation Polygon Area Setting Modal
 * This modal allows users to set insulation area properties before drawing polygons.
 * @log first created at 2026/02/12
 * @returns
 */
export const InsulationAreaSettingModal = ({
  isOpen,
  isOnStage,
  /** area type: polygon | default */
  selectType,
  lazyCloseHandler,
}: ModalOpenProps & { selectType: string }) => {
  const ias = useInsulationAreaSetting(selectType as AreaType);

  const cancelHandler = () => {
    lazyCloseHandler();
    document.dispatchEvent(new Event(TKEvent.CANCEL_POLYGON_TOOL));
  };

  const startHandler = () => {
    lazyCloseHandler();
    ias.applyInsulationAreaSettingHandler();
  };

  // !! migrated to layer manager default zone select
  // const defaultHandler = () => {
  //   lazyCloseHandler();
  //   ias.applyInsulationDefaultSettingHandler();
  // };

  return (
    <AnimateModal
      isOpen={isOpen}
      isOnStage={isOnStage}
      lazyCloseHandler={cancelHandler}
      title={`New Insulation Area Settings`}
      containerClass="w-auto max-h-full"
    >
      {/* Insulation Category */}
      <h2 className="color-primary text-sm my-2">SERVE CATEGORY</h2>
      <div className="flex my-0 gap-6 w-80">
        <ImageRaidoButton
          label="DUCT"
          value="DUCT"
          name="category"
          selectedValue={ias.serveCategory}
          selectChangeHandler={ias.categoryChangeHandler}
        />
        <ImageRaidoButton
          label="PIPE"
          value="PIPE"
          name="category"
          selectedValue={ias.serveCategory}
          selectChangeHandler={ias.categoryChangeHandler}
        />
      </div>

      {/* Area Name */}
      {ias.areaMode == 'polygon' && (
        <label className="color-primary text-sm block my-2">
          AREA NAME
          <input
            type="text"
            name="namePrefix"
            className="block w-full px-2 py-1.5 mt-1 text-sm frame-input"
            value={ias.namePrefix}
            onChange={ias.namePrefixChangeHandler}
            placeholder="e.g. ROOM, ROOM-1"
          />
        </label>
      )}

      {/* Expose type - area type */}
      <label className="color-primary text-sm block my-2">
        INSULATION AREA
        <select
          name="exposeType"
          className="block w-full px-2 py-1.5 mt-1 text-sm frame-input"
          value={ias.exposeType}
          onChange={ias.exposeTypeChangeHandler}
        >
          {INSULATION_AREA_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>

      {/* Button Row */}
      <div className="flex gap-x-10 justify-between mx-0 mt-4">
        {/* Cancel button */}
        <button
          className="btn-red-border color-red font-semibold flex-1 red-shadow"
          onClick={cancelHandler}
        >
          Cancel
        </button>
        {/* Start button - disabled for default area (no polygon to draw) */}
        <button
          className="btn-green flex-1 leading-5 text-base shadow-md disabled:opacity-40 disabled:cursor-not-allowed"
          hidden={ias.areaMode === 'default'}
          disabled={!ias.namePrefix}
          onClick={startHandler}
        >
          Start
        </button>
        {/* Apply button for `default` area setting saving */}
        {/* <button
          className="btn-blue flex-1 leading-5 text-base shadow-md disabled:opacity-40 disabled:cursor-not-allowed"
          hidden={ias.areaMode === 'polygon'}
          onClick={defaultHandler}
        >
          Apply
        </button> */}
      </div>
    </AnimateModal>
  );
};
